import {combineReducers} from 'redux';

import recordsReducer from './recordsSlice';

const entityKey = 'resetPassword';

const stateReducer = combineReducers({
    records: recordsReducer,
});

export default stateReducer;
